import { ViewModel } from 'view_models/view_model'
import { Coupon } from 'entities/coupon'

export class CouponViewModel extends ViewModel<Coupon> {
    public discountPrice = (): string | undefined => {
        if (this.object.discountPrice) {
            return this.object.discountPrice?.toLocaleString() + '円'
        }
    }
    public discountRate = (): string | undefined => {
        if (this.object.discountRate) {
            return Math.round(this.object.discountRate * 100) + '%'
        }
    }
}
